// @flow
import * as React from 'react';
import ImpressionTracker from 'app/common/lib/react/ImpressionTracker';
import ProductPin from 'app/common/react/components/shopping/ProductPin/DeprecatedProductPin';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import { Box } from 'gestalt';
import { getRichTypes } from 'app/common/lib/CommerceUtil';
import { getViewParameter } from 'app/common/react/components/closeup/lib';
import { hasPin } from 'app/common/react/components/closeup/utils';
import { track } from 'app/common/lib/react/analytics';

type Props = {|
  pins: Array<Object>,
  user: ProfileUser,
|};

export default function ProductPinsCarousel(props: Props) {
  const { pins, user } = props;
  const lastIndex = pins.length - 1;

  const handleClick = (index) => {
    if (index === lastIndex) {
      track(PCONST.thrift.EventType.CLICK, {
        view: PCONST.thrift.ViewType.PIN,
        viewParameter: getViewParameter(hasPin(props)),
        component: PCONST.thrift.ComponentType.USER_OVERVIEW,
        element: PCONST.thrift.ElementType.SEE_MORE_BUTTON,
      });
    }
  };

  return (
    <Box display="flex">
      {pins.map((product, index) => (
        <Box key={index}>
          <Box justifyContent="center" display="flex" width="100%">
            <Box maxWidth={750} width="100%" paddingX={3}>
              <Box paddingY={3} width="100%">
                <ImpressionTracker
                  key={`profile-product-pins-impression-key-${product.id}`}
                  impressionType="Pin"
                  impressionAuxFields={{
                    richTypes: getRichTypes(product),
                    imageURL: product.images && product.images['236x'].url,
                  }}
                  loggingId={product.id}
                  slotIndex={index}
                  viewData={{ user_id: user.id }}
                  viewType={PCONST.thrift.ViewType.USER}
                  viewParameter={getViewParameter(hasPin(props))}
                  componentType={PCONST.thrift.ComponentType.PIN_CLOSEUP_RELATED_PRODUCTS}
                >
                  <Box direction="column" display="flex" key={product.id}>
                    <ProductPin
                      link={
                        index === lastIndex ? `/${user.username}/_shop/` : `/pin/${product.id}/`
                      }
                      imageSizeKey={'236x'}
                      onClick={() => {
                        handleClick(index);
                      }}
                      pin={product}
                      showOverlay={index === lastIndex}
                      showProductIcon
                      squared
                      inCarousel
                      componentType={PCONST.thrift.ComponentType.PIN_CLOSEUP_RELATED_PRODUCTS}
                      viewData={{ user_id: user.id }}
                      viewType={PCONST.thrift.ViewType.USER}
                      viewParameter={getViewParameter(hasPin(props))}
                    />
                  </Box>
                </ImpressionTracker>
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
